import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { TextBlock } from '@amzn/dvui/dist/TextBlock'
import * as st from './notificationAction.module.scss'
import { ConditionalText } from '../../utils/conditionalText'
import * as hoverClasses from '../../widgets/Hover/hoverComponent.module.scss'
import * as cn from 'classnames'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'
import { removeDVStringLinebreaks } from '../../utils/stringUtils'

export interface ITextBlockNotificationProps extends AtfTreatmentProps {
  messages?: WpsRuntime.atv.wps.DVStringList
}

export const TextBlockNotification = ({ messages, atfTreatment }: ITextBlockNotificationProps) => {
  if (!messages || !messages.length) {
    return null
  }
  // TODO: AVWebDetailPage-1831
  return (
    <>
      { messages.map((message, idx) => (
          <ConditionalText key={`text-block-conf-text-${idx}`} Tag={TextBlock} className={cn(st.notificationBox, hoverClasses.buttonOverride,
            {[cn(st.notificationBoxRedesign, 'avu-full-width-phablet')]: isTreatment(atfTreatment,'T1', 'T2', 'T3')},
            {[cn(st.roundedBox)]: isTreatment(atfTreatment,'T1', 'T3')}
            )} message={isTreatment(atfTreatment,'T1', 'T2', 'T3') ? removeDVStringLinebreaks(message) : message} />
        ))}
    </>
  )
}
